/**
 * DetailRow Component
 * ===================
 * Display a labeled detail with an icon.
 */
export const DetailRow = ({ icon: Icon, label, value, className = "" }) => {
  if (!value) return null;
  return (
    <div className={`flex items-start gap-2 ${className}`}>
      <Icon className="w-3.5 h-3.5 text-zinc-500 mt-0.5 flex-shrink-0" />
      <div className="flex-1 min-w-0">
        <span className="text-[10px] font-semibold text-zinc-500 uppercase tracking-wider">{label}</span>
        <p className="text-sm text-zinc-300">{value}</p>
      </div>
    </div>
  );
};

/**
 * DetailSection Component
 * =======================
 * A section wrapper for grouped details.
 */
export const DetailSection = ({ title, children, className = "" }) => (
  <div className={`space-y-2 ${className}`}>
    <h4 className="text-[10px] font-bold text-zinc-500 uppercase tracking-wider border-b border-zinc-800 pb-1">
      {title}
    </h4>
    <div className="space-y-2">
      {children}
    </div>
  </div>
);

export default DetailRow;
